import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import * as moment from 'moment';

import { FormControl, FormBuilder,FormGroup } from '@angular/forms';



import {log, logModel} from "../../model/logsModel"
import {personModel, statsRecord} from "../../model/personModel"
export enum enumFitnessEvent { 'Running', 'Swimming','Walking','Cycling' };

export class durationValidator {
    static isValid(control: FormControl): any {
        var dur = moment(control.value, 'HH:mm:ss');
        var duration = dur.hour() * 60 * 60 + dur.minute() * 60 + dur.second();
        console.log(duration);
        if (duration == 0) {
            return { 'Duration should be greater than zero': true }
        }        
        
        return null;
    }
}
export class mileageValidator {
    static isValid(control: FormControl): any {
        if (isNaN(control.value)) {
            return {
                "not a number": true
            };
        }
        if (control.value == 0) {
            return {
                "not a number": true
            };
        }
        return null;
    }
}
@Component({
  selector: 'page-add-log',
  templateUrl: 'add-log.html'
})
export class AddLogPage {
    addlog: log;
    timeStarts: string;
    duration: string;

    events: Array<string> = ['Running', 'Cycling', 'Swimming','Walking'];
    runningTypes: Array<string> = ['Aerobic', 'Tempo', 'Long Slow Distance', 'Recovery', 'Time Trial', 'Conversational','Others'];
    cyclingTypes: Array<string> = ['Road', 'Off road','Others'];
    swimmingTypes: Array<string> = ['Open waters', 'Swimming pool', 'Sea','Others'];
    swimmingStyleTypes: Array<string> = ['Freestyle', 'Breast Stroke', 'Front Crawl', 'Others'];
    ratingTypes: Array<string> = ['1.Almost Killed', '2.Tiring', '3.Comfortable', '4.Cake walk', '5.Timepass Run',];
    minDate: string;
    maxDate: string;
    distancePattern: string = "[0�9]+([\.][0�9]+)?";
    addLogForm: FormGroup;
    constructor(
        public navCtrl: NavController,
        public navParams: NavParams,
        public logModel: logModel,
        public personModel: personModel,
        public statsRecord: statsRecord,
        public formBuilder: FormBuilder

    ) {
        this.addlog = new log('', '');
        this.addlog.milage = 0;
        this.addlog.duration = 10;
        this.addlog.event = this.events[0];
        this.addlog.runningType = this.runningTypes[0];
        this.addlog.cyclingTypes = this.cyclingTypes[0];
        this.addlog.swimmingTypes = this.swimmingTypes[0];
        this.addlog.swimmingStyleTypes = this.swimmingStyleTypes[0];
        this.addlog.rating = this.ratingTypes[2];

        this.timeStarts = new Date().toISOString();
        this.duration = "00:00:00";
        var now = moment(new Date());
        this.maxDate = now.format("YYYY-MM-DD");
        this.minDate = now.subtract(15, "d").format("YYYY-MM-DD");
        this.addLogForm = this.formBuilder.group({
            'duration': ["00:00:00",durationValidator.isValid],
            'milage':[0,mileageValidator.isValid]
        });
        
    }

  ionViewDidLoad() {  
    console.log('ionViewDidLoad AddLogPage'); 
    }
  log(val) {
      console.log(val);
      return val;
  }
  save() {
      console.log(this.addlog);
      this.addLogForm.updateValueAndValidity({'onlySelf':true,'emitEvent':true});
      if (this.addLogForm.invalid) return;      
      var data = "" + this.addlog.milage;
      this.addlog.milage = parseFloat(data);
      this.addlog.person = this.personModel.me.key;   
      var dur = moment(this.duration,'HH:mm:ss');
      this.addlog.duration = dur.hour()*60*60+ dur.minute()*60+dur.second();
      var dat = moment(this.timeStarts);
      this.addlog.day = dat.date();
      this.addlog.month = dat.month() + 1;
      this.addlog.year = dat.year();
      this.addlog.week = dat.week();
      this.logModel.createlog(this.addlog);
      this.statsRecord.addTo('year',this.addlog.year,this.addlog.event,  this.addlog.milage);
      this.statsRecord.addTo('month', this.addlog.month, this.addlog.event, this.addlog.milage);
      this.statsRecord.addTo('week', dat.week(), this.addlog.event, this.addlog.milage);
      this.navCtrl.pop();
  }
  cancel() {
      this.navCtrl.pop();
  }

}



// WEBPACK FOOTER //
// ./src/pages/add-log/add-log.ts